// en_US language file
// Generated from Feishu Bitable
// Total entries: 565

export default{
    "game_diamond": {
        "title": "Game Diamond Info",
        "title0_title": "How to Get Game Diamonds",
        "title0": {
            "txt1": "1. Earn them through specific tasks or events.",
            "txt2": "2. Cannot be purchased with top-up."
        },
        "title1_title": "Game Diamond Usage",
        "title1": {
            "txt1": "1. Only used for games.",
            "txt2": "2. In-game, Game Diamonds work the same as regular diamonds and can be used directly. Diamonds won with Game Diamonds are regular diamonds.",
            "txt3": "3. Game Diamonds are used first.",
            "txt4": "4. Can be combined with diamonds. E.g., if you have 200 Game Diamonds and 800 Diamonds, using 1000 will consume both."
        },
        "title2_title": "Game Diamond Validity",
        "title2": {
            "txt1": "1. Valid for a limited time and will be reclaimed after expiration."
        }
    },
    "guanxi_gift_rule_title": "Gift Descriptions",
    "guanxi_gift_rule_1": "After sending a relationship gift, the recipient can choose whether to form a relationship with you. Only one relationship can exist between two people at a time.",
    "guanxi_gift_rule_2": "Each person can have up to 3 relationships, and the relationship types can be the same.",
    "guanxi_gift_rule_3": "You can end a relationship 24 hours after forming it. After ending a relationship, you can form a new one after another 24 hours.",
    "not_exist": "Not found",
    "mbti_intro_title": "MBTI Descriptions",
    "mbti_intro_pers": "Personality Traits",
    "mbti_intro_love": "Romantic Traits",
    "mbti_intro_istj_pers": "Inspector Personality",
    "mbti_intro_istj_feature": "Serious, quiet, detail-oriented, and precise, they prefer an orderly and structured life. Reliable and responsible, they follow rules and traditions.",
    "mbti_intro_istj_love": "In love, ISTJs are loyal, stable partners. They take relationships seriously, focusing on commitment and responsibility, showing their care through actions rather than words, needing time to form deep connections.",
    "mbti_intro_isfj_pers": "Caregiver Personality",
    "mbti_intro_isfj_feature": "Gentle, kind, and empathetic, they are attentive to others' needs and patient. Detail-oriented, they are great listeners and supporters.",
    "mbti_intro_isfj_love": "In relationships, ISFJs are deeply caring, attentive to their partner’s life details, and create a cozy and warm atmosphere. Often traditional, they may take time to commit but are very loyal once they do.",
    "mbti_intro_infj_pers": "Architect Personality",
    "mbti_intro_infj_feature": "Insightful and creative, with a deep understanding of humanity and the future. They have rich inner lives and are thoughtful and analytical.",
    "mbti_intro_infj_love": "INFJs look for mental and emotional connection with partners, valuing deep conversations. They have high ideals in love and, when in love, are focused and devoted.",
    "mbti_intro_intj_pers": "Commander Personality",
    "mbti_intro_intj_feature": "Logical, calm, and confident with strong analytical and decision-making skills, they value knowledge and wisdom and pursue goals tenaciously.",
    "mbti_intro_intj_love": "In relationships, INTJs approach love rationally, valuing shared beliefs and goals. Though reserved with emotions, they show their care through thoughtful actions.",
    "mbti_intro_istp_pers": "Craftsman Personality",
    "mbti_intro_istp_feature": "Practical, observant, and analytical, they enjoy hands-on tasks and solving practical problems, especially in mechanical or technical areas.",
    "mbti_intro_istp_love": "ISTPs are spontaneous and free-spirited in relationships, enjoying the present moment with their partners, and sharing life’s pleasures without much restriction.",
    "mbti_intro_isfp_pers": "Artist Personality",
    "mbti_intro_isfp_feature": "Sensitive, gentle, and artistic, they prioritize emotional and sensory experiences, often expressing themselves through creative forms.",
    "mbti_intro_isfp_love": "In relationships, ISFPs are romantic and considerate, skilled at creating a charming atmosphere, and often delight their partners with surprises. They can be emotional and need a partner who understands and supports them.",
    "mbti_intro_infp_pers": "Mediator Personality",
    "mbti_intro_infp_feature": "Idealistic, kind, and empathetic, they have rich inner lives and a strong understanding of human nature, valuing harmony and beauty.",
    "mbti_intro_infp_love": "INFPs invest deeply in relationships, seeking strong emotional connections. They value emotional exchanges and share a hopeful view of love.",
    "mbti_intro_intp_pers": "Logician Personality",
    "mbti_intro_intp_feature": "Analytical and curious, they have a strong desire for knowledge, exploring unknown areas in pursuit of truth.",
    "mbti_intro_intp_love": "In relationships, INTPs are logical, focusing on intellectual and emotional compatibility. While they may be reserved in expressing feelings, they use discussions to foster mutual understanding.",
    "mbti_intro_estp_pers": "Entrepreneur Personality",
    "mbti_intro_estp_feature": "Energetic, outgoing, and adventurous, they enjoy social interactions and risk-taking, seizing opportunities actively.",
    "mbti_intro_estp_love": "In relationships, ESTPs are vibrant and passionate, loving to explore new experiences with their partners. They are straightforward, openly expressing their thoughts and feelings.",
    "mbti_intro_esfp_pers": "Performer Personality",
    "mbti_intro_esfp_feature": "Outgoing, optimistic, and expressive, they enjoy socializing and entertainment, bringing energy and enthusiasm.",
    "mbti_intro_esfp_love": "In love, ESFPs are lively partners who enjoy shared social activities, emphasizing present feelings and experiences, bringing joy and excitement to their partners.",
    "mbti_intro_enfp_pers": "Campaigner Personality",
    "mbti_intro_enfp_feature": "Creative, energetic, and warm, they love engaging with others and deeply understand others’ emotions.",
    "mbti_intro_enfp_love": "ENFPs are like the sunshine in relationships, bringing warmth and joy to their partners. Full of romance, they actively express their love and look forward to creating beautiful memories together.",
    "mbti_intro_entp_pers": "Debater Personality",
    "mbti_intro_entp_feature": "Smart, witty, and inquisitive, they enjoy debating and exploring new ideas and subjects.",
    "mbti_intro_entp_love": "ENTPs engage in deep discussions and debates with partners, enjoying challenge and intellectual growth in love. Often playful, they bring humor to the relationship.",
    "mbti_intro_estj_pers": "Executive Personality",
    "mbti_intro_estj_feature": "Practical, decisive, and confident, with strong organization and leadership skills, they prioritize efficiency and results.",
    "mbti_intro_estj_love": "In love, ESTJs are assertive and determined, actively pursuing their interests and planning for the future. They show affection through practical support and actions.",
    "mbti_intro_esfj_pers": "Consul Personality",
    "mbti_intro_esfj_feature": "Friendly and warm, they are social and care for others, valuing tradition and family bonds.",
    "mbti_intro_esfj_love": "ESFJs are attentive and nurturing partners, creating a harmonious, warm romantic environment. Often traditional, they appreciate familiar dating customs and family approval.",
    "mbti_intro_enfj_pers": "Protagonist Personality",
    "mbti_intro_enfj_feature": "Charismatic and confident, they connect easily and communicate well, understanding and guiding others effectively.",
    "mbti_intro_enfj_love": "ENFJs are enthusiastic and romantic partners, openly expressing their love and creating a warm atmosphere. They value emotional exchange and aim to form a deep bond with their partners.",
    "mbti_intro_entj_pers": "Executive Personality",
    "mbti_intro_entj_feature": "Logical, confident, and driven, with strong leadership and decision-making abilities, they value excellence and success, holding high standards for themselves and others.",
    "mbti_intro_entj_love": "In love, ENTJs are goal-oriented, choosing like-minded partners who support mutual growth. They prioritize competence and shared ambitions, deepening relationships through shared goals.",
    "expressProposalWall": "Proposal Wall Rule",
    "expressHowTo": "How to get on the Proposal Wall",
    "expressSend": "Send the proposal gift to your lover and your text of expressing love will be shown on the Proposal Wall.",
    "expressSend1": "1.Tap \"Proposal Now\", you can jump to the party and select the user to send your love words.",
    "expressSend2": "2.Select the gift and enter the words you want to say to him/her on the card.",
    "expressSend3": "3.Tap to send the gift and your proposal card will be shown on the wall.",
    "expressDifferent": "Different Types of Proposal Gifts",
    "expressWeHave": "We have 4 types of Proposal Gifts as follows.",
    "expressWeHave1": "1.Basic Proposal Gift Card: Simple color background.",
    "expressWeHave2": "2.Decoration Proposal Gift Card: Decorative colorful background.",
    "expressWeHave3": "3.Luxury Proposal Gift Card: Decorative background in luxury effect.",
    "expressWeHave4": "4.True Love Proposal Gift Card: Decorative background in luxury effect, and with fancy server-wide notification bar.",
    "expressProposal": "Proposal Card Display Range",
    "expressProposal1": "1.Proposal Wall in room.(Tap the bar above the proposal gifts)",
    "expressProposal2": "2.Proposal Wall Next to the Moment page.",
    "diamondDrop1": "1. When a user sends gifts totaling over 50,000 diamonds in a room (lucky gifts are calculated at 0.1 times their value), a diamond chest drops that anyone in the room can open to grab diamonds.",
    "diamondDrop2": "2. Each chest has a 1-minute countdown before it can be opened.",
    "diamondDrop3": "3. Diamonds in each chest are limited; once the countdown ends, you can’t claim diamonds from that chest anymore.",
    "diamondDrop4": "4. After the chest closes, you can click to see how many diamonds you snagged from it.",
    "baoxaingxianding": "Treasure Gift Limit",
    "cancelAccount": {
        "accountRecoveryContent": "During the recovery period, you can log back in using your previous method and choose to recovery your account. Once recoveried, you’ll regain all your account messages, levels and diamond.",
        "accountRecoveryTitle": "Account Recovery:",
        "confirmCancellation": "Are you sure you want to delete?",
        "convalescenceContent": "After submitting a deletion request, your account will be temporarily disabled for 30 days. During this time, all your account information, levels, and diamonds will be retained, allowing for a seamless recovery if you change your mind.",
        "convalescenceTitle": "Recovery Period:",
        "finalContent": "If you do not choose to recovery your account by the end of the recovery period (31 days from the deletion request), your account and all associated data will be permanently deleted. Please note that once deleted, your account and data cannot be recovered.",
        "finalTitle": "Final Deletion:",
        "reserveContent": "During the recovery period, we will protect your account data to ensure it is not lost or damaged.",
        "reserveTitle": "Data Retention:",
        "statementContent": "Deletion Request: After you submit an account deletion request, your account will enter a 30-day “recovery period.” During this time, you can choose to recovery your account at any point. If you are part of a agency, account deletion will not be possible.",
        "statementTitle": "Account Deletion Notice:",
        "userContent": "Thank you for using our services. We understand that you may sometimes need to deletion your account. To ensure your decision is well-considered and to provide an opportunity for reconsideration, we outline the account deletion process and related terms here.",
        "userTitle": "Dear User:"
    },
    "Countdown": "Countdown",
    "Endactivity": "Event Ended",
    "eventDetails": "Event Details",
    "eventGifts": "Event Gifts",
    "eventList": "Event Leaderboard",
    "eventReward": "Event Rewards",
    "eventRewards": {
        "player": "Daily Active Players",
        "proportion": "Prize Return Rate",
        "title": "Event Prizes",
        "txt1": "1. Data from the previous day is calculated daily at 00:00 (UTC+8).",
        "txt2": "2. Prizes are awarded based on the number of participants and the actual diamonds spent in the room (user bets minus user winnings).",
        "txt3": "3. Data for the previous week is calculated every Monday at 00:00 (UTC+8), and rewards are distributed within 3 days.",
        "txt4": "4. Prize Return Rate:",
        "txt5": "5. Definition of Active Player: A player who bets more than 1,000 diamonds in a day."
    },
    "EventRules": "Event Rules",
    "Eventtime": "Event Time",
    "guild": {
        "guild_certification01": "Agency Verification",
        "guild_certification02": "Welcome Agency",
        "guild_certification03": "Recruitment Requirements",
        "guild_certification04": [
            "Completed 10 signed anchors and settled in within one week",
            "Able to provide the agency leader’s ID and other real-name documents",
            "Provide a agency profile, team introduction, anchor information, anchor earnings rules, etc."
        ],
        "guild_certification05": "If you meet the above requirements, send your information to the official email: billionairepte@gmail.com Once approved, a staff member will contact you.",
        "guild_certification06": "Copied to clipboard",
        "guild_certification07": "Contact for Inquiry",
        "guild_certification08": "Copy",
        "guild_certification09": "Membership Information",
        "guild_certification10": [
            {
                "title": "1. Membership Rules",
                "value": [
                    "Applicants must agree with the agency leader to initiate a membership request on the platform. Once approved by the leader, they become a signed anchor, contributing to the agency."
                ]
            },
            {
                "title": "2. Resignation Rules",
                "value": [
                    "To leave the agency after joining, the anchor needs to agree with the agency leader. Click “Leave Agency” on the agency profile page. The agency leader must click “Agree to Leave” and then the member will exit the agency.",
                    "After the withdrawal is successful, you can apply to join other agency."
                ]
            }
        ],
        "guild_certification11": "Agency Information",
        "guild_certification12": [
            {
                "title": "Agency Earnings",
                "value": [
                    "Users and anchors in family rooms receive gifts, generating agency contributions.",
                    "Boss attacks occur in family rooms.",
                    "Anchors signed with the agency create CP rooms, and receiving gifts generates agency contributions. (Unsigned anchor cannot create CP rooms and generate family contributions after joining the family.)"
                ]
            }
        ],
        "InvitationCodeTitle": "Invitation Code",
        "invite_rules_intriduction": "Invitation Rules",
        "invite_rules_intriduction_content": [
            "Anchors can apply to join your agency and become a anchors by entering the invitation code during registration.",
            "Anchors who did not enter an invitation code during registration can apply to join your family through the family page, and then apply to become a anchor."
        ]
    },
    "legend": {
        "title": "Legendary February"
    },
    "officialMember": "Official Staff",
    "prettyNumber": {
        "text": "Ⅰ. Special ID Collection",
        "text1": "After reaching Noble Level 3 or higher, you can claim a Special ID corresponding to your level.",
        "text2": "Higher-level nobles can claim a lower-level Special ID. For example, a Noble 6 can claim a Level 3 Special ID.",
        "text3": "When your noble status expires, the Special ID also becomes unavailable. You need to reactivate your noble to continue using the Special ID.",
        "text5": "Once you claim a Special ID, you cannot exchange it for another number of the same or lower level.",
        "text6": "If you achieve a higher noble level while using a Special ID, you can immediately switch to a higher-level Special ID, and the original ID will return to the store.",
        "text7": "For example, a Noble 4 user who initially claims a Noble 4 Special ID and then upgrades to Noble 6 cannot switch to a Noble 4 or lower Special ID, but can immediately claim a Noble 6 Special ID.",
        "title": "Explanation",
        "title1": "Ⅱ. Special ID Expiration",
        "title2": "Ⅲ. Special ID Replacement"
    },
    "reception": {
        "reception01": "Gift Leaderboard Explanation",
        "reception02": [
            {
                "title": "What is the Room Gift Leaderboard?",
                "value": [
                    "The Room Gift Leaderboard is a real-time ranking of gifts received in the room",
                    "Room gift count = Diamond gift count"
                ]
            },
            {
                "title": "How is the Room Gift Leaderboard ranked?",
                "value": [
                    "The ranking is determined based on the total income of all rooms, calculated comprehensively",
                    "Hourly Leaderboard: Resets every hour at UMT+8",
                    "Daily Leaderboard: Resets at 00:00 UMT+8 every day"
                ]
            },
            {
                "title": "Top 1 on the Hourly Leaderboard is broadcasted server-wide",
                "value": [
                    "The top 1 room on the hourly gift leaderboard is announced across all server rooms"
                ]
            }
        ]
    },
    "roomParty": {
        "back": "Return",
        "event_rule": "<p>1. Duration Leaderboard: Tracks the total time users spend in the room's all mic positions during the event. The top 3 contributors in the top 3 rooms will receive rewards.</p><p>2. Generosity Leaderboard: Tracks the total number of diamonds received in the room during the event. The top 3 diamond spenders in the top 3 rooms will receive rewards.</p><p>3. This event is a weekly cycle event, with the leaderboard resetting and recalculating each week.</p>",
        "last_week": "Last Week",
        "last_week_rank": "Last Week's Leaderboard Details",
        "reward": "Rewards",
        "rich_rank": "Room Gift Leaderboard",
        "rule": "Rules",
        "rule_reward": "Rules & Rewards",
        "time_rank": "Duration Leaderboard",
        "title": "Family Room",
        "top1": "TOP1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_1_name": "Frame for 14 days",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/mount/thunder_armor.png?t=1666610955",
        "top1_pictures_2_name": "Effects for 14 days",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_3_name": "Frame for 14 days",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_4_name": "Frame for 7 days",
        "top2": "TOP2",
        "top3": "TOP3"
    },
    "TopUpRewards": "TopUp Rewards",
    "treasure_chest": {
        "title": "Treasure Chest Gift Instructions",
        "value1": "There are three types of treasure chests: Wooden, Silver, and Gold.",
        "value2": "When you open a treasure chest, you will randomly receive a gift from the chest and send it out.",
        "value3": "The sender earns experience points based on diamonds spent, while the recipient receives Coins and charm points based on the gift value from the chest.",
        "value4": "Wooden Chest, priced at 1500 diamonds, contains the following gifts:",
        "value5": "Silver Chest, priced at 7500 diamonds, contains the following gifts:",
        "value6": "Gold Chest, priced at 25000 diamonds, contains the following gifts:",
        "value7": "Treasure chest gifts are for entertainment and social interaction only. Any actions affecting fairness or exploiting product bugs will be prohibited. If detected, the platform will ban the account and reserves the right to pursue legal action."
    },
    "treasure_name": {
        "name1": "Wooden Chest",
        "name2": "Silver Chest",
        "name3": "Gold Chest",
        "name4": "Probability"
    },
    "Value": "Value:",
    "Webname": {
        "addUid": "Add UID",
        "balance": "Balance:",
        "Confirm": "Confirm",
        "err_uid": "Invalid UID, please re-enter",
        "lang": "Select Language",
        "Query": "Search",
        "recharge": "Recharge Center",
        "Recharge": "Top-Up",
        "self": "Channel",
        "uid": "Change UID",
        "uuserName": "Nickname:",
        "Withdrawal": "Withdraw"
    },
    "Weekly_Cp": {
        "7days": "7 days",
        "back": "Back",
        "countdown": "Countdown to this week",
        "day": "Days",
        "diamonds": "https://image.pocketliveapp.com/image/activity/New%20Folder/diamonds.png",
        "event_rule": "<p>Notes</p><p>1. All rewards will be credited to your account within 3-5 business days after the event ends.</p><p>2. The leaderboard calculates the diamonds spent on sending event gifts to other users. 1 diamond = 1 CP point, and the top 3 CP pairs with the highest CP points will receive event rewards.</p><p>3. The event ends every Monday at 00:00 (UTC+8), and the values for the previous week are settled.</p><p>4. Only 10% of the diamonds spent on lucky gifts will be counted.</p>",
        "gift": "Event Gifts",
        "hour": "Hour",
        "last_week": "Last week",
        "last_week_rank": "Last week's list",
        "minute": "Minute",
        "pocketcoins": "https://image.pocketliveapp.com/image/activity/New%20Folder/coins.png",
        "reward": "Rewards",
        "rule": "Rules",
        "rule_reward": "Rules & Rewards",
        "seconds": "Seconds",
        "title": "Soulmate",
        "top1": "TOP1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top1_pictures_1_name": "Weekly Star Avatar Frame",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top1_pictures_2_name": "Best Support Avatar Frame",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/2011_cloth_female.png?t=1678879041",
        "top1_pictures_34_name": "Weekly Star Outfit",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/2010_suit_male.png?t=1678879038",
        "top2": "TOP2",
        "top2_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top2_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top3": "TOP3",
        "top3_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top3_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top46": "TOP 4-6",
        "top710": "TOP7-10"
    },
    "Withdrawal": "Withdrawal Instructions",
    "withdrawalInstructions": {
        "text1": "The withdrawal feature is currently available in select countries only.",
        "text2": "The time it takes for withdrawals to be processed may vary depending on the channel.",
        "text3": "The actual amount received may be slightly lower than the displayed amount due to exchange rate fluctuations and fees.",
        "text4": "You can only withdraw once per day.",
        "text5": "If you encounter any issues, please contact us."
    },
    "withdrawalLogin": {
        "accountId": "Pix account ID",
        "accountIdTips": "",
        "accountIdtsa": "Pix account ID cannot be empty",
        "accountType": "Pix account type",
        "code": "Verification code:",
        "Confirm": "Confirm",
        "documentId": "Personal ID number",
        "documentIdTips": "",
        "documentIdtsa": "ID type cannot be empty",
        "documentType": "ID type",
        "getAccount": "Get account",
        "getUserId": "Please enter user ID",
        "incorrectAccount": "Incorrect account",
        "login": "Login",
        "loginSuccessful": "Login successful",
        "name": "Pix username",
        "nameTips": "",
        "nametsa": "Length must be between 5 and 100 characters",
        "officialGroup": "If you have any questions, please contact our official support.",
        "pocket": "Pocket Coin balance",
        "Pocket": "Insufficient Pocket Coin balance",
        "Send": "Send",
        "text": "Verification code will be sent within the app",
        "title": "Earnings withdrawal",
        "title2": "Withdrawal details",
        "user_id": "Account ID:",
        "Whatsapp": "Incorrect Whatsapp account",
        "WhatsappTips": "",
        "applicationTime": "Request Date",
        "amount": "Withdrawal Amount",
        "success": "Success",
        "applicationSuccess": "Request Submitted"
    },
    "top1AnchorRewards": "Top 1 Anchor Rewards",
    "top2_3AnchorRewards": "Top 2-3 Anchor Rewards",
    "top4_10AnchorRewards": "Top 4-10 Anchor Rewards",
    "top1Icon7day": "Avatar Frame*7D",
    "top1_2Icon7day": "Entrance Effect*7D",
    "top3Icon7day": "Avatar Frame*7D",
    "top1VIPRewards": "Top 1 VIP Rewards",
    "top2_3VIPRewards": "Top 2-3 VIP Rewards",
    "top4_10VIPRewards": "Top 4-10 VIP Rewards",
    "relastionship": {
        "des": [
            "",
            "1. After sending a relationship gift, the other party can choose whether to establish a relationship with you. Only one type of relationship can exist between two people.",
            "2. Within 7 calendar days (UTC+3) after establishing a relationship, intimacy will not decay. After this protection period, if intimacy does not increase by 50 points in a day, it will decay by 10% at 00:00 the next day (minimum decay is 1). When intimacy reaches 0, the relationship will be unbound at 00:00 the next day. If intimacy doesn’t increase by 50 points for 10 consecutive days, the relationship will automatically end at 00:00.",
            "3. You can end the relationship 24 hours after forming it. After ending it, you can re-establish a relationship 24 hours later.",
            "4. Each person has 3 relationship slots by default. You can spend diamonds to buy more, each slot costs 99,999 diamonds, and you can purchase up to 10. You can also increase your slots by raising your VIP level.",
            "VIP Level",
            "Total expandable relationship slots"
        ]
    },
    "gift_album_des1": "Sending the above gifts can help him/her light up the Weekly Album - \"World Tour\" and get rewards.",
    "gift_album_des2": "Sending the above gifts can help him/her light up the Permanent Album - \"Heart Throb\" and get rewards.",
    "gift_album_des3": "Sending the above gifts can help him/her light up the Permanent Album - \"SVIP Guard\" and get rewards.",
    "gift_album_des4": "Sending the above gifts can help him/her light up the Permanent Album - \"Dream Wedding\" and get rewards.",
    "gift_album_des5": "Go to [Profile] - [Gift Wall] - [Album] to view details",
    "gift_album_des8": "Sending the above gifts can help him/her unlock the permanent collection - 'Birthday Party' and receive rewards.",
    "gift_album_des7": "Sending the above gifts can help him/her light up the Permanent Album - \"Room Star\" and get rewards.",
    "gift_harifata": "Burj Khalifa",
    "gift_sailing_hotel": "Burj Al Arab",
    "gift_mosque": "Grand Mosque",
    "gift_abatta": "Abate Tower",
    "gift_sphinx": "Sphinx",
    "svip_gift_1": "SVIP1",
    "svip_gift_2": "SVIP2",
    "svip_gift_3": "SVIP3",
    "svip_gift_4": "SVIP4",
    "svip_gift_5": "SVIP5",
    "svip_gift_6": "SVIP6",
    "gift_conf_lv1": "Love Heartbeat",
    "gift_conf_lv2": "Love Struck",
    "gift_conf_lv3": "Love Boundless",
    "gift_conf_lv4": "No one But you",
    "gift_habibi": "Habibi",
    "gift_bestie": "Bestie",
    "gift_couple": "Couple",
    "gift_confidant": "Confidant",
    "weding_gift_kiss": "Kiss",
    "weding_gift_ring": "Ring",
    "weding_gift_proposal": "Proposal",
    "weding_gift_castle": "Castle",
    "weding_gift_wedding_dress": "Wedding Dress",
    "weding_gift_wedding": "Wedding",
    "gift_album_des6": "Rules",
    "guild_can_with": "Available",
    "guild_with_ing": "Processing",
    "guild_self_withdraw": "Self Withdrawal",
    "guild_transfer_to_leader": "Transfer to Agency Leader",
    "guild_salary_to_reseller": "Transfer to Reseller",
    "guild_convert_to_diamond": "Convert to Diamonds",
    "guild_platform_settlement": "Platform Settlement",
    "guild_withdrawal_records": "Withdrawal History",
    "guild_current_withdrawable_pcoin": "Available Cion",
    "guild_transfer_pcoin_amount": "Amount to Transfer",
    "guild_all": "All",
    "guild_read_before_withdraw": "Read before withdrawing:",
    "guild_withdraw_note_1": "Submit",
    "guild_withdraw_note_2": "Insufficient Withdrawable Coins",
    "guild_min_withdraw_amount": "Confirm submission?",
    "guild_withdraw_note_4": "Cancel",
    "guild_appeal_to_platform": "Confirm",
    "guild_submit_application": "Withdrawal Method",
    "guild_withdraw_below_min": "Leader Withdrawal",
    "guild_confirm_submit_application": "Request Time",
    "guild_freeze_notice": "Processing Time",
    "guild_communicate_with_leader": "Rejection Reason",
    "guild_cancel": "Amount Refunded",
    "guild_confirm": "Pending",
    "guild_withdrawal_method": "Completed",
    "guild_leader_withdraw": "Rejected",
    "guild_status_timeout_rejected": "Auto-rejected (Timeout)",
    "guild_status_unknown": "Unknown",
    "guild_status_platform_review": "Under Platform Review",
    "guild_status_guild_review": "Under Agency Review",
    "guild_status_timeout_rejected_2": "Timeout, Returned",
    "guild_status_platform_rejected": "Platform Rejected",
    "guild_status_guild_leader_approval": "Forwards to Agency in <span>{n}</span>h",
    "guild_apply_time": "Last 3 months records only",
    "guild_process_time": "Questions about withdrawals?",
    "guild_rejection_reason": "Contact Support",
    "guild_amount_refunded": "Verified Reseller",
    "guild_status_pending": "Reseller Only",
    "guild_status_completed": "Available",
    "guild_status_rejected": "Transfer Amount",
    "guild_show_last_3_months": "Estimated Arrival",
    "guild_withdrawal_question": "Success",
    "guild_contact_customer_service": "Convert to Diamonds",
    "guild_certified_reseller": "Available Coins to Convert",
    "guild_not_reseller_cannot_transfer": "Convert",
    "guild_current_withdrawable": "Converted",
    "guild_transfer_amount": "Settled Coin",
    "guild_estimated_arrival": "Request Submitted",
    "guild_read_before_operation": "1. Please confirm offline payment details with the Reseller in advance",
    "guild_transfer_note_1": "2. Transfers are only supported to a Reseller",
    "guild_transfer_note_2": "Confirm Transfer",
    "guild_confirm_transfer": "Confirm submission?",
    "guild_confirm_submit_transfer": "{n} coins will be deducted",
    "guild_deduct_pcoin_receive_diamond": "Please coordinate payment details with the Reseller",
    "guild_communicate_with_reseller": "Transaction Successful",
    "guild_operation_success": "Convert to Diamonds",
    "guild_exchange_diamond": "Available Coins to Convert",
    "guild_current_exchangeable_pcoin": "Convert",
    "guild_exchange": "Conversion Successful",
    "guild_exchange_success": "Coins to Be Settled",
    "guild_settlement_pcoin_amount": "1. Please confirm the withdrawal method with Operations Team in advance",
    "guild_settlement_note_1": "2. Payments will be processed next Monday",
    "guild_settlement_note_2": "3. Minimum withdrawal amount: {n} Coins",
    "guild_settlement_min_amount": "Request Submitted",
    "guild_application_submitted": "{n} Coins will be deducted",
    "guild_deduct_pcoin": "Please coordinate payment details with the Operations Team",
    "guild_user_not": "User not found",
    "guild_please_enter_amount": "Enter amount",
    "guild_insufficient_balance": "Insufficient balance",
    "guild_please_enter_reseller_uid": "Enter RESELLER UID",
    "guild_please_search_reseller_first": "Please search for the RESELLER first",
    "guild_select_hand": "Select an action",
    "guild_ci_hand": "1. This action will submit a request to the Guild Leader,",
    "guild_offline_transfer_funds": "and the payment will be made to you offline by the leader",
    "guild_ci_hand_2": "2. Please confirm the payout method with the leader in advance (bank card / USDT, etc.)",
    "guild_ci_hand_3": "3. Minimum withdrawal amount is {n} Coins",
    "guild_ci_hand_4": "4. If the leader confirms payment but you have not received it, please keep the chat records and",
    "guild_ci_hand_5": "submit an appeal to the platform",
    "guild_ci_hand_6": "The system will freeze {n} Coins until the leader processes it",
    "guild_ci_hand_7": "Please confirm the withdrawal channel with the leader; payment is handled offline",
    "guild_tips_1": "Withdrawable Coins below minimum",
    "guild_contact_service": "Please contact operations to arrange the payment",
    "guild_reseller_tips": "Your coins are now the other user’s diamonds. Please talk to them about the payment.",
    "gift_collection_detail_permanent_birthday": "Birthday Party",
    "gift_collection_detail_permanent_roomstar": "Room Star",
    "gift_holy_sword": "Holy Sword",
    "gift_volcano": "Volcano",
    "gift_emperor_come_world": "The Emperor of Europe Comes to the World",
    "gift_castle_of_love": "Castle of Love",
    "gift_Immortal_god_war": "Immortal God of War",
    "gift_king_of_gods": "King of Gods",
    "birthday_gift_cybergift": "Cyber Gift",
    "birthday_gift_wish": "Lamp Wish",
    "birthday_gift_cake": "Golden Cake",
    "birthday_gift_lion": "Lion's Blessing",
    "birthday_gift_biggift": "Luxury Gift",
    "guild_page_fee": "$2 fee per withdrawal",
    "guild_page_saudi": "Saudi Arabia",
    "guild_page_morocco": "Morocco",
    "guild_page_bank": "Bank",
    "guild_page_name": "Name (English)",
    "guild_page_name_english": "Name must be in English",
    "guild_page_bank_number": "Bank Account Number",
    "guild_page_enter": "Enter a valid bank account number",
    "guild_page_address": "Address (English)",
    "guild_page_address_english": "Address must be in English",
    "guild_page_country": "Country/Region",
    "guild_page_holder_name": "Account Holder Name",
    "guild_page_sa": "e.g. SA8200000000XXXXXXXXXXXX",
    "guild_page_format": "Format: Street, Area, City, State, Country",
    "guild_page_minimum": "3. Minimum withdrawal amount is {n} Coins",
    "withdraw_input_amount": "Enter amount",
    "withdraw_submit": "Withdraw",
    "withdraw_quantity": "Withdrawal amount",
    "withdraw_actual_received": "Actual amount received",
    "common_confirm": "Confirm",
    "common_cancel": "Cancel",
    "withdraw_error_min_amount": "Minimum withdrawal not met",
    "withdraw_error_max_amount": "Exceeds max withdrawal limit",
    "withdraw_error_max_p_coin": "Exceeds available coins",
    "guild_can_with_usd": "Withdrawable (≈USD {n})",
    "guild_pending_settlement": "Pending Settlement",
    "guild_funds_operation": "Fund Operation",
    "guild_withdrawable_amount_title": "Withdrawable Amount",
    "guild_withdrawable_amount_tip1": "1. To ensure the safety of funds and reduce security risks, the system will perform a risk control review on each coins income. During the review period, coins will be in the 'Pending Settlement' status.",
    "guild_withdrawable_amount_tip2": "2. Review will be completed within {s} hours at the latest. If approved, coins will move from 'Pending Settlement' to 'Withdrawable'; if not approved, the system will handle it according to the rules.",
    "guild_withdrawable_amount_tip3": "3. In special cases such as withdrawal failure and refunds, you can withdraw immediately.",
    "guild_got_it": "Got it",
    "guild_pending_settlement_detail": "Pending settlement details",
    "guild_pending_settlement_tip": "Gold coin earnings will become 'withdrawable amount' after completing secure settlement, and are expected to enter your withdrawable balance within {s} hours at the latest.",
    "guild_pending_settlement_amount": "Pending Settlement Amount",
    "guild_pending_settlement_last_30_days": "Only showing records from the past {n} hours",
    "guild_pending_settlement_list_tips": "Only unsettled earnings from the past {n} hours are displayed. Amounts that have been used or deducted will not be shown here; you may go to",
    "guild_pending_settlement_list_tips_btn": "Coins Record Page",
    "guild_pending_settlement_list_tips_look": "View",
    "guild_pending_stamp_settled": "Settled",
    "guild_pending_stamp_used": "Used",
    "guild_pending_stamp_deducted": "Deducted",
    "guild_record_guild_reward": "Agency rewards",
    "guild_record_gift": "Receive gift",
    "guild_order_id": "Order ID",
    "guild_withdraw_record_total": "Total {s} items",
    "guild_status_reseller_review": "reseller reviewing",
    "guild_status_security_review": "Security review",
    "guild_select_withdraw_amount": "Select withdrawal amount",
    "guild_reference_fee": "Service fee",
    "guild_change_channel": "Change",
    "guild_change_channel_title": "Change channel",
    "guild_current_can_withdraw": "Currently withdrawable",
    "guild_confirm_bind": "Confirm Binding",
    "guild_bind_notice_title": "Tip",
    "guild_bind_tip_1": "The name must match the real-name authentication of the account.",
    "guild_bind_tip_2": "Incorrect account information may result in withdrawal failure and inability to receive money. Please carefully confirm each detail before submitting.",
    "guild_confirm_withdraw_info": "Confirm withdrawal information",
    "guild_withdraw_amount_label": "Withdrawal amount",
    "guild_estimated_arrival_time": "Estimated arrival time",
    "guild_confirm_info_tip": "Please carefully confirm the withdrawal information. If there is something wrong in the information, the order will not succeed.",
    "guild_modify": "Edit",
    "guild_confirm_submit": "Confirm submission",
    "guild_withdraw_success_tip": "It is expected to finish in {s} working days. Please wait patiently. You can go to the [Withdrawal page] - [Withdrawal Records] in the upper right corner to check the progress.",
    "guild_name": "Name",
    "guild_bank_account": "Bank Account",
    "guild_please_enter": "Please enter",
    "guild_withdraw_submit_success": "Submission successful",
    "guild_withdraw_success_tip2": "The funds are expected to arrive within {s} business days. Please wait patiently. You can check the progress by going to [Withdrawal] - [Withdrawal Records] in the top right corner.",
    "guild_platform_settlement_success_tip": "Payments will be processed collectively next Monday. Please be patient. You can check the progress by going to the [Withdrawal Page] and selecting [Withdrawal Records] at the top right.",
    "guild_transfer_to_reseller": "Transfer to distributor",
    "guild_transfer_to_reseller_label": "Transfer to RESELLER",
    "guild_reseller_confirm_desc": "Please confirm with the RESELLER about the payment arrangements. After you click 'Confirm', you will deduct",
    "guild_reseller_confirm_tip_1": "1. Please communicate with the reseller in advance regarding the offline payment arrangements.",
    "guild_reseller_confirm_tip_2": "2. If the other party declines, your coins will be automatically returned;",
    "guild_reseller_confirm_tip_3": "3. The minimum withdrawal amount is {n} coins.",
    "guild_leader_settle_subtitle": "The agency leader will settle with you offline",
    "guild_leader_confirm_desc": "Please make sure you have discussed the payment details with the agency leader. Once you click 'Confirm', coins will be deducted.",
    "guild_leader_confirm_tip_1": "1. This operation will send a request to the agency leader, who will transfer the payment to you offline;",
    "guild_leader_confirm_tip_2": "2. Please confirm the payment method (bank card/USDT, etc.) with the agency leader in advance; if the agency leader refuses, your coins will be automatically returned;",
    "guild_leader_confirm_tip_3": "3. The minimum withdrawal amount is {n} coins;",
    "guild_leader_confirm_tip_4": "4. If the agency leader confirms the payment has been made but you have not received the money, please keep the chat record and file an appeal to the platform.",
    "guild_leader_confirm_tip_4_prefix": "5. If the agency leader confirms that the payment has been made but you have not received the money, please keep the chat records and appeal to the platform.",
    "guild_leader_platform_appeal": "Appeal to the platform",
    "pixNamePlaceholder": "Enter pix username",
    "pixIdType": "ID Type",
    "transfer": {
        "bindSuccess": "Binding successful",
        "error": "Operation failed, please try again later."
    },
    "pixSelectIdTypePlaceholder": "Select ID type",
    "pixIdPlaceholder": "Enter your {s}",
    "pixSelectAccountTypePlaceholder": "Select pix account type",
    "pixAccountPlaceholder": "Enter your {s}",
    "whatsAppIdPlaceholder": "Enter your WhatsApp ID",
    "pixCpfLengthError": "CPF must be 11 digits",
    "pixCnpjLengthError": "CNPJ must be 14 digits",
    "pixCpfNotMatchError": "The two CPF entries are inconsistent",
    "pixCnpjNotMatchError": "The two entered CNPJ values do not match",
    "pixFormatError": "Format error",
    "notFilled": "{s} not filled in",
    "formatErrorCheck": "Format error, please check.",
    "certi_tips": "Tip",
    "certi_tips1": "To protect your account security and reduce the risk of malicious attacks, you need to complete verification before proceeding. Please go to 'Me' > 'Verification Center' in the app to complete verification before continuing.",
    "certi_tips2": "Go to verify",
    "certi_tips3": "The current version is too old. Please upgrade and try again.",
    "certi_tips4": "To protect your account security and reduce the risk of malicious attacks, please complete verification to continue.",
    "ff": "Rocket Launch: Take on High Multipliers!",
    "dd": "Take Off Now",
    "guild_country": "Country/Region",
    "guild_bank_name": "Bank",
    "guild_iban": "IBAN",
    "guild_whatsapp": "WhatsApp",
    "guild_document_type": "ID Type",
    "guild_document_id": "ID Number",
    "guild_account_type": "Account Type",
    "guild_address": "Address",
    "guild_settlement_weekly_process": "Processed uniformly every Monday",
    "withdrawal_channel": "Withdrawal Channel",
    "guild_whatsapp_contact_tip": "Please leave your contact information, we will contact you via WhatsApp",
    "guild_bind": "Bind",
    "guild_settlement_input_amount": "Enter withdrawal amount",
    "gift_sphinx6": "Pyramid",
    "gift_sphinx7": "Monas Tower",
    "guild_no_more_data": "No more content",
    "guild_bind_channel_toast": "Please bind channel information first"
}
